import React, { PureComponent } from 'react'
import styles from './PlaceItem.scss'
import FasEye from '@components/Icons/font-awesome/FasEye'
import config from '@public-config'
import moment from 'moment'
import { SimpleImg } from 'react-simple-img'
import { parseOpenHours } from '@libs/placeHelper'
import FavoriteButtonContainer from '@components/FavoriteButton'
import { imageAssetUrl, openPost } from '@libs/appUrl'
import getDistanceAndWalkTime from '@libs/getDistanceAndWalkTime'

const LIMIT_DAYS_FOR_NEW_PLACE = 7
const LIMIT_VIEWS_FOR_HOT_PLACE = 200

class PlaceItem extends PureComponent {
  static defaultProps = {
    isShowOpenHours: true,
  }
  state = {
    distance: '',
    walkTime: '',
  }
  componentDidMount() {
    const { myLat, myLng, item, t } = this.props
    const { distance, walkTime } = getDistanceAndWalkTime({ myLat, myLng, item, t })
    this.setState({ distance, walkTime })
  }
  render() {
    const { item, myLat, myLng, t, isShowOpenHours } = this.props
    const { walkTime, distance } = this.state
    return (
      <div className="placeItem" onClick={this._onClickPlaceItem}>
        <style jsx>{styles}</style>
        <div className="placeItem__thumbOuter">
          {item.get('hasCoupon') && <div className="badgeCoupon">{t('優惠')}</div>}
          <SimpleImg
            className="placeItem__thumb"
            height={100}
            width={100}
            applyAspectRatio={true}
            alt={item.getIn(['place', 'name'])}
            src={`${config.imageBaseUrl}/${item.getIn(['img', 0, 'thumb'])}`}
          />
        </div>
        <div className="placeItem__info">
          <div className="placeItem__titleOuter">
            <div className="placeItem__title">
              <a href={this._getPostLink()} onClick={this._onClickPlaceLink}>
                {item.getIn(['place', 'name'])}
              </a>
            </div>
            {!!item.getIn(['place', 'clap', 'score']) && (
              <div className="placeItem__clap">
                <img src={imageAssetUrl('icon/small-clap@3x.png')} />
                <span>{item.getIn(['place', 'clap', 'score'])}</span>
              </div>
            )}
            <div className="placeItem__actionOuter">{this._renderCallAction()}</div>
          </div>
          <div className="placeItem__priceOuter">
            {!!item.getIn(['place', 'priceRange']) && (
              <div className="placeItem__price">
                {t('均價')} ${item.getIn(['place', 'priceRange'])}/{t('每人')}
              </div>
            )}
          </div>
          <div className="placeItem__openHours">
            {this._isOpen() ? (
              <span className="placeItem__openStatus">{t('營業中')}</span>
            ) : (
              <span className="placeItem__closeStatus">{t('休息中')}</span>
            )}
            {isShowOpenHours && <span className="placeItem__openText">{this._getOpenText()}</span>}
          </div>
          <div className="placeItem__distance">
            {!!myLat && !!myLng ? (
              <React.Fragment>
                <span>{distance}</span>
                {!!walkTime && <span>，{t('步行{{walkTime}}分鐘', { walkTime })}</span>}
                <div className="placeItem__starOuter">
                  <FavoriteButtonContainer
                    defaultTopicList={item.get('topics') ? item.get('topics') : null}
                    savedNum={item.get('saved') < 0 ? 0 : item.get('saved')}
                    postId={item.get('postID')}
                    postItem={item}
                    via="place.card"
                    isAddToDefault={true}
                  />
                </div>
              </React.Fragment>
            ) : (
              <div>
                <FasEye className="iconEye" />
                <span>{item.get('view')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
  _onClickPlaceItem = () => {
    openPost(this._getPostLink(), '_route')
  }
  _isOpen = () => {
    const { item, t } = this.props
    if (!item.getIn(['place', 'openHours'])) {
      return 'undefined'
    }
    const openHours = item.getIn(['place', 'openHours']).toJS()
    const { openNow } = parseOpenHours(openHours, t)
    return openNow
  }
  _getOpenText = () => {
    const { item } = this.props
    if (!item.getIn(['place', 'openHours'])) {
      return ''
    }
    const now = new Date()
    let opentText = item.getIn([
      'place',
      'openHoursText',
      now.getDay() === 0 ? 6 : now.getDay() - 1,
    ])
    opentText = opentText.replace(/星期一|星期二|星期三|星期四|星期五|星期六|星期日/g, '')
    opentText = opentText.replace(':', '')
    opentText = opentText.trim()
    return `，${opentText}`
  }
  _renderCallAction = () => {
    const { item, t } = this.props
    if (moment().diff(moment(item.get('t')), 'days') <= LIMIT_DAYS_FOR_NEW_PLACE) {
      return (
        <div className="placeItem__action placeItem__action--new">
          <div className="placeItem__text">{t('最新')}</div>
        </div>
      )
    } else if (item.get('placeViews') > LIMIT_VIEWS_FOR_HOT_PLACE) {
      return (
        <div className="placeItem__action placeItem__action--hot">
          <div className="placeItem__text">{t('熱門')}</div>
        </div>
      )
    } else {
      return null
    }
  }
  _onClickPlaceLink = (e) => {
    e.preventDefault()
  }
  _getPostLink = () => {
    const { item, via } = this.props
    const tmpId = item.get('postID').split('.')[1]
    return `/place/${tmpId}?via=${via}`
  }
}

export default PlaceItem
